import { containsIgnoreCase } from '@dte/otw-utils-core/src/strings/equalsIgnoreCase';
import { LocationType, type LocationV2 } from '../../../interfaces/api/Location';

export function isNonPremiseLocationType(locationType: LocationType | undefined): locationType is LocationType {
	return containsIgnoreCase([LocationType.CrossStreet, LocationType.GLN], locationType);
}

export function isGLNLocationType(type: LocationType): boolean {
	return type === LocationType.GLN;
}

export function isNonPremiseLocation(location: LocationV2 | undefined): location is LocationV2 {
	return isNonPremiseLocationType(location?.type);
}
